'use client'

import * as React from 'react'
import { cn } from '../../helpers/index.js'
import { Text } from '../../components/text.js'
import FreeGiftItem from './FreeGiftItem.js'
import type { FreeGift, FreeGiftWithSelection } from './types.js'

export interface GiftSelectionProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 赠品标签文本 */
  freeGiftLabel?: string
  /** 赠品列表（包含选择状态） */
  freeGifts?: FreeGiftWithSelection[]
  /** 赠品点击回调 */
  onGiftClick?: (gift: FreeGift) => void
  /** 赠品类型 1-> 单选模式， 2 -> 全选模式 */
  giftType?: 1 | 2
  selectedGiftSku?: string
}

/**
 * GiftSelection - 赠品选择区域
 */
const GiftSelection = React.forwardRef<HTMLDivElement, GiftSelectionProps>(
  ({ freeGiftLabel, freeGifts, onGiftClick, className, giftType }, ref) => {
    if (!freeGifts || freeGifts.length === 0) {
      return null
    }

    return (
      <div ref={ref} className={cn('flex w-full flex-col gap-2', className)}>
        {freeGiftLabel && (
          <Text size={2} className={cn('text-info-primary desktop:text-[16px] lg-desktop:text-[18px] w-full')}>
            {freeGiftLabel}
          </Text>
        )}
        <div className={cn('tablet:flex-row laptop:flex-col flex flex-col gap-2')}>
          {freeGifts.map((gift, index) => (
            <div key={gift.id || index} className="min-w-0 flex-1">
              <FreeGiftItem gift={gift} onClick={onGiftClick} giftType={giftType} />
            </div>
          ))}
        </div>
      </div>
    )
  }
)

GiftSelection.displayName = 'GiftSelection'

export default GiftSelection
